import { render } from "./BaseProgress.vue?vue&type=template&id=62bb654a&scoped=true"
import script from "./BaseProgress.vue?vue&type=script&lang=js"
export * from "./BaseProgress.vue?vue&type=script&lang=js"

import "./BaseProgress.vue?vue&type=style&index=0&id=62bb654a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-62bb654a"

export default script